import { useEffect, useState } from 'react';

const padWithZero = (number: number) => (number < 10 ? '0' : '') + number;

export function formatTimeRemaining(timeLeft: number): string {
  const timeLeftAsObject = {
    hours: Math.floor(timeLeft / (1000 * 60 * 60)),
    minutes: Math.floor((timeLeft / 1000 / 60) % 60),
    seconds: Math.floor((timeLeft / 1000) % 60)
  };

  const paddedHours = padWithZero(timeLeftAsObject.hours);
  const paddedMinutes = padWithZero(timeLeftAsObject.minutes);
  const paddedSeconds = padWithZero(timeLeftAsObject.seconds);

  return timeLeftAsObject.hours > 0
    ? `${paddedHours}:${paddedMinutes}`
    : `${paddedMinutes}:${paddedSeconds}`;
}

export default function useUnlockTimer(
  unlockDateTime: string | null | undefined
): number | null {
  const [currentTime, setCurrentTime] = useState(() =>
    unlockDateTime ? Date.parse(unlockDateTime) : Date.now()
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !unlockDateTime) return;

    setCurrentTime(Date.now());

    const interval = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000);

    return () => clearInterval(interval);
  }, [unlockDateTime]);

  if (!unlockDateTime) return null;

  const unlockTime = Date.parse(unlockDateTime);
  const timeLeft = unlockTime - currentTime;

  return timeLeft > 0 ? timeLeft : null;
}
